if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');
      this.addButton = this.querySelector('.card__buttons product-form .product-info__add-button .btn[name="add"]');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }

      this.updateAddButtonText();
      this.handleStockStatusClone();

      // Cập nhật khi resize
      window.addEventListener('resize', () => {
        this.updateAddButtonText();
        this.handleStockStatusClone();
      });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });

      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }

    updateAddButtonText() {
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      const backInStockButton = this.querySelector('.OpenBackInStockModal');
      if (backInStockButton && backInStockButton.querySelector('.product-form__submit__title')) {
        backInStockButton.querySelector('.product-form__submit__title').textContent = isMobile ? 'NOTIFY ME' : 'NOTIFY ME WHEN BACK IN STOCK';
      }
      if (!this.addButton) return;
      this.addButton.textContent = isMobile ? '+ Add' : 'Add to Cart';

    }

    handleStockStatusClone() {
      const isDesktop = window.innerWidth > 768;
      const cardInfoHead = this.querySelector('.card-info-head');
      const heading = cardInfoHead?.querySelector('.sticky-atc-panel__heading');
      const existingClone = cardInfoHead?.querySelector('.pdp-stock-status.cloned');

      if (isDesktop) {
        if (!existingClone) {
          const stockStatus = document.querySelector('.pdp-stock-status');
          if (stockStatus && cardInfoHead && heading) {
            const cloned = stockStatus.cloneNode(true);
            cloned.classList.add('cloned');
            heading.insertAdjacentElement('afterend', cloned);
          }
        }
      } else {
        if (existingClone) existingClone.remove();
      }
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
